import Vue from 'vue';
import VueRouter from 'vue-router';

import { compareRecords, decorateRecords } from 'vue/router/api-helpers.js';


const DEBUG = globals.config.debug;
export let router;


/**
 * Initialize vue-router
 */
function init(appRoot) {
    Vue.use(VueRouter);

    const routes = decorateRecords(appRoot.store, globals.config.routeData.routes || []);
    const initialRoute = (window.location.pathname + window.location.search);

    router = new VueRouter({
        mode: 'history',
        routes,
        linkActiveClass: 'u-router-active',
        scrollBehavior(from, to, savedPosition) {
            return savedPosition || { x: 0, y: 0 };
        },
    });

    // Call hook before every route transition
    router.beforeEach((to, from, next) => {
        DEBUG && console.log('[router] - beforeEach hook');
        const hasMatches = (to.matched && to.matched.length);
        const areRecorsIdentical = compareRecords(to, from);
        const isInitialRoute = (initialRoute === to.fullPath);

        // Simple link without corresponding route record
        if (!hasMatches && !isInitialRoute) {
            DEBUG && console.log('[router] - No matches found, following path url');
            window.location.href = to.path;
            return;
        }

        // TODO: Remove monkey patch for styleguide with: `if (!to.meta.reload) {`
        if (to.meta.page === 'page-styleguide') {
            window.location.href = to.path;
            return;
        }

        // djangoCMS edit mode
        if (!isInitialRoute && globals.config.cmsEditMode && !areRecorsIdentical) {
            DEBUG && console.log('[router] - djangoCMS edit mode, following path url');
            window.location.href = to.path;
            return;
        }

        // Registered route record
        DEBUG && console.log('[router] - Following matched route');
        next();
    });

    // Assign props to the appRoot
    appRoot.router = router;
}

export default init;



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/router/index.js